import {useFormikContext, Field } from "formik";
import React from "react";

function Expenses() {
  const { errors, touched } = useFormikContext();

  return (
    <div>
 <h2 class="heading1">Outgoings</h2>
<p>Provide details on any outgoings you have. Not all options will be relevant to you. Answer all relevant questions and provide as accurate information as possible.</p>
<fieldset class="question-section" >
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="mortgage">Mortgage</label>  
        <span class="inline pound-font">£</span>
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="mortgage" name="mortgage" class="input-width--300"/>
    </div>
    <div>
        <div class="form__control form__radio">
            <Field type="radio" id="mortgage-per-weekly" name="mortgage_per" value="0"/>
            <label class="form__label" htmlFor="mortgage-per-weekly"><span>Weekly</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="mortgage-per-monthly" name="mortgage_per" value="1" />
            <label class="form__label" htmlFor="mortgage-per-monthly"><span>Monthly</span></label>
        </div>
    </div>
</fieldset>   
<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="rent">Rent (minus any housing benefits)</label>  
        <span class="inline pound-font">£</span> 
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="rent" name="rent" class="input-width--300"/>
    </div>
    <div>
        <div class="form__control form__radio">
            <Field type="radio" id="rent-per-weekly" name="rent_per" value="0"/>
            <label class="form__label" htmlFor="rent-per-weekly"><span>Weekly</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="rent-per-monthly" name="rent_per" value="1" />
            <label class="form__label" htmlFor="rent-per-monthly"><span>Monthly</span></label>
        </div>
    </div>
</fieldset>   
<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="counciltax">Council tax (minus any council tax benefit)</label>  
        <span class="inline pound-font">£</span>
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="counciltax" name="counciltax" class="input-width--300"/>
    </div>
    <div>
        <div class="form__control form__radio">
            <Field type="radio" id="counciltax-per-weekly" name="counciltax_per" value="0"/>
            <label class="form__label" htmlFor="counciltax-per-weekly"><span>Weekly</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="counciltax-per-monthly" name="counciltax_per" value="1" />
            <label class="form__label" htmlFor="counciltax-per-monthly"><span>Monthly</span></label>
        </div>
    </div>
</fieldset>   

<fieldset class="question-section" >
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="servicecharge">Service charge (for rented accommodation e.g. 24 hour warden support)</label>  
        <span class="inline pound-font">£</span>
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="servicecharge" name="servicecharge" class="input-width--300"/>
    </div>
    <div>
        <div class="form__control form__radio">
            <Field type="radio" id="servicecharge-per-weekly" name="servicecharge_per" value="0"/>
            <label class="form__label" htmlFor="servicecharge-per-weekly"><span>Weekly</span></label>
        </div>
        <div class="form__control form__radio">
            <Field type="radio" id="servicecharge-per-monthly" name="servicecharge_per" value="1"/>
            <label class="form__label" htmlFor="servicecharge-per-monthly"><span>Monthly</span></label>
        </div>
    </div>
</fieldset>   
    </div>
  );
}
export default Expenses;